import React from 'react'
import OfficesAbout from '../components/OfficesAbout'
import TeamAbout from '../components/TeamAbout'
import map from '../assets/imagenes/about-us-1.png'

import '../styles/Nosotros/About.css'

import { useTranslation } from 'react-i18next'


function About() {
const {t} = useTranslation();

  return (
    <>
        <div className="title-container">
            <div className='txt-title'>
                <h2 style={{fontFamily: 'Outfit, sans-serif', fontWeight: '700', margin: '20px' }}>{t("about")}</h2>
            </div>
        </div>
        <section className="aboutUs-container">
            <div className='map-container' >
                <img src={map} alt="map" className='map'/>
            </div>
            <div className='quienes-somos'>
                <h6 style={{fontFamily: 'Outfit, sans-serif', fontWeight: '600', color: '#017C79'}}>{t("who_we_are")}</h6>
                <h4 style={{fontFamily: 'Roboto, sans-serif', color: '#000', fontWeight: '600'}}>{t("about_1")}</h4>
                <p style={{fontFamily: 'Roboto, sans-serif', color: '#000', fontWeight:'400'}}>{t("about_2")}</p>
                <p style={{fontFamily: 'Roboto, sans-serif', color: '#000', fontWeight:'400'}}>{t("about_3")}</p>
                <p style={{fontFamily: 'Roboto, sans-serif', color: '#000', fontWeight:'400'}}>{t("about_4")}</p>
                <p style={{fontFamily: 'Roboto, sans-serif', color: '#000', fontWeight:'400'}}>{t("about_5")}</p>
            </div>
        </section>
        <OfficesAbout />
        <TeamAbout />
    </>
  )
}

export default About